module.exports = __webpack_public_path__ + "img/slide5.d9a93f25.png";